// src/components/ui/Modal.tsx

import React, { useEffect } from "react";

interface Props {
  title: React.ReactNode;
  icon?: string;
  iconColor?: string;
  size?: "md" | "lg";
  onClose: () => void;
  /** Mientras se guarda no se puede cerrar con Esc ni haciendo clic afuera */
  busy?: boolean;
  children: React.ReactNode;
}

export default function Modal({
  title,
  icon,
  iconColor,
  size = "md",
  onClose,
  busy,
  children,
}: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !busy) onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose, busy]);

  return (
    <div
      className="modal-overlay"
      onMouseDown={(e) => e.target === e.currentTarget && !busy && onClose()}
    >
      <div
        className={`modal-box ${size === "lg" ? "modal-lg" : ""}`}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-title">
          {icon && (
            <i
              className={`bi ${icon}`}
              style={{ color: iconColor ?? "var(--tp-primary)" }}
            />
          )}
          <span style={{ flex: 1 }}>{title}</span>
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={onClose}
            disabled={busy}
            style={{ color: "var(--tp-muted)" }}
            aria-label="Cerrar"
          >
            <i className="bi bi-x-lg" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
